import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import LinearGauge from "@amzn/meridian/esm/components/linear-gauge";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import { THEME_COLOR } from "../../../../styles/colors";

const ProgressIndicator = ({ label, current, max, unit }) => {
  const safeMax = max > 0 ? max : 1;
  const safeCurrent = Math.min(current || 0, safeMax);
  const displayUnit = unit || "items";

  return (
    <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.MIST_GRAY, boxBorderRadiusOutline: 12 }}>
      <Box type="outline" spacingInset="400">
        <Column spacing="200">
          {label && <Text type="h50">{label}</Text>}
          <LinearGauge minValue={0} maxValue={safeMax} value={safeCurrent} trackWidth={8} height={8} />
          <Text type="b200" color="secondary">
            {current || 0}/{max || 0} {displayUnit}
          </Text>
        </Column>
      </Box>
    </Theme>
  );
};

export default ProgressIndicator;
